/**
 * Recruit Accordion - Frontend Script
 */
document.addEventListener('DOMContentLoaded', () => {
	const closeButtons =
		document.querySelectorAll<HTMLButtonElement>('.accordion__close');

	closeButtons.forEach((button) => {
		button.addEventListener('click', () => {
			const details = button.closest('details');
			if (details) {
				details.removeAttribute('open');

				// スムーズスクロールでsummaryの位置に戻る
				const summary = details.querySelector('summary');
				if (summary) {
					const rect = summary.getBoundingClientRect();
					const offset = window.scrollY + rect.top - 100; // 100px上に余白

					window.scrollTo({
						top: offset,
						behavior: 'smooth',
					});
				}
			}
		});
	});
});
